export default "__VITE_ASSET__Dgg757IU__"